<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="row" id="main-content">
  @if (false) {
    <div id="side-menu"  (mouseenter)="toggleReportsMenu()"  (mouseleave)="toggleReportsMenu()"  [className]="showMenu ? 'side-menu-expanded' : ''">
      <div class="label">Reports</div>
      <div class="report-menu">
        <ul>
          <li (click)="showReport(Reports.Kpi)">KPI</li>
          <li (click)="showReport(Reports.Inventory)">Container Report</li>
        </ul>
      </div>
    </div>
  }

  <div class="col-12">
    @if (reportToShow == Reports.Kpi && kpiData.length > 0) {
      <div>
        <div class="row">
          <div class="col-12">
            @if (hasMultipleDepots) {
              <mat-form-field appearance="fill" style="width: 15%" subscriptSizing="dynamic">
                <mat-label>Depot</mat-label>
                <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
                  @for (depot of depotList; track depot) {
                    <mat-option [value]="depot.id">{{depot.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field appearance="fill" style="width: 10%" subscriptSizing="dynamic">
              <mat-label>Type</mat-label>
              <mat-select [(value)]="selectedDepotId" (selectionChange)="assetTypeChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
                @for (asset of assetTypeList; track asset) {
                  <mat-option [value]="asset.id">{{asset.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button (click)="exportData()" class="btn btn-white btn-sm float-right">
              Export Data
              <span class="svg-icon svg-icon-xs ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>ionicons-v5-a</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
              </span>
            </button>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card-body row">
            <div class="col-10">
              <table class="w-100">
                <thead>
                  <tr>
                    <th class="first-col"><div class="header-div"><p>&nbsp;</p></div></th>
                    @for (item of kpiData; track item) {
                      <th><div class="header-div"><p>{{ item.displayDate | date:'d MMM' }}</p></div></th>
                    }
                  </tr>
                </thead>
                <tbody class="dummy">
                  <tr>
                    <td class="h-2" [attr.colSpan]="kpiData.length + 1"><div></div></td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td class="row-header first-col"><div>Containers at Customer</div></td>
                    @for (item of kpiData; track item) {
                      <td> {{ item.containersAtCustomer }}</td>
                    }
                  </tr>
                  <tr>
                    <td class="row-header"><div>Containers at Depot</div></td>
                    @for (item of kpiData; track item) {
                      <td> {{ item.containersAtDepot }}</td>
                    }
                  </tr>
                  <tr>
                    <td class="row-header"><div>Containers at Other Locations</div></td>
                    @for (item of kpiData; track item) {
                      <td> {{ item.containersAtOther }}</td>
                    }
                  </tr>
                  <tr class="highlight">
                    <td class="row-header"><div>Total Containers</div></td>
                    @for (item of kpiData; track item) {
                      <td> {{ item.totalContainers }}</td>
                    }
                  </tr>
                  <tr class="padding-row"><td [attr.colSpan]="kpiData.length + 1"><div></div></td></tr>
                  <tr class="divider-row"><td [attr.colSpan]="kpiData.length + 1"></td></tr>
                  <tr class="padding-row"><td [attr.colSpan]="kpiData.length + 1"><div></div></td></tr>
                  <tr>
                    <td class="row-header"><div>Collections</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.collectionsInWeek }}</td>
                    }
                  </tr>
                  <tr>
                    <td class="row-header"><div>Deliveries</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.deliveriesInWeek }}</td>
                    }
                  </tr>
                  <tr>
                    <td class="row-header"><div>Exchanges</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.exchangesInWeek }}</td>
                    }
                  </tr>
                  <tr class="highlight">
                    <td class="row-header"><div>Total Jobs</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.totalJobs }}</td>
                    }
                  </tr>
                  <tr class="padding-row"><td [attr.colSpan]="kpiData.length + 1"><div></div></td></tr>
                  <tr class="divider-row"><td [attr.colSpan]="kpiData.length + 1"></td></tr>
                  <tr class="padding-row"><td [attr.colSpan]="kpiData.length + 1"><div></div></td></tr>
                  @if (isAdmin && showTotalContainerDays()) {
                    <tr>
                      <td class="row-header"><div>Total Container Days</div></td>
                      @for (item of kpiData; track item) {
                        <td> {{ item.totalContainerDays }}</td>
                      }
                    </tr>
                  }
                  <tr class="highlight">
                    <td class="row-header"><div>Slow Movers</div></td>
                    @for (item of kpiData; track item) {
                      <td> {{ item.slowMovers }}</td>
                    }
                  </tr>
                  @if (isAdmin &&showSlowMovingDays()) {
                    <tr>
                      <td class="row-header"><div>Slow Moving Days</div></td>
                      @for (item of kpiData; track item) {
                        <td> {{ item.slowMovingDays }}</td>
                      }
                    </tr>
                  }
                  <tr class="highlight">
                    <td class="row-header"><div>Average Container Dwell</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.averageContainerDwell | number:'1.1-1' }}</td>
                    }
                  </tr>
                  <tr style="display: none;">
                    <td class="row-header"><div>Service Frequency Average</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.serviceFrequencyAverage | number:'1.1-1' }}</td>
                    }
                  </tr>
                  <tr style="display: none;">
                    <td class="row-header"><div>Projected Annual Collections</div></td>
                    @for (item of kpiData; track item) {
                      <td>{{ item.projectedAnnualCollections | number:'1.1-1' }}</td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-2">
              <table class="w-100">
                <thead>
                  <tr>
                    <th><div class="header-div"><p>4 Week %</p></div></th>
                    <th><div class="header-div"><p>12 Week %</p></div></th>
                  </tr>
                </thead>
                <tbody class="dummy">
                  <tr>
                    <td class="h-2" colspan="2"><div></div></td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.containersAtCustomer > 0 ? 'increase' : fourWeekTrend.containersAtCustomer < 0 ? 'decrease' : ''">{{ fourWeekTrend.containersAtCustomer | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.containersAtCustomer > 0 ? 'increase' : twelveWeekTrend.containersAtCustomer < 0 ? 'decrease' : ''">{{ twelveWeekTrend.containersAtCustomer | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.containersAtDepot > 0 ? 'increase' : fourWeekTrend.containersAtDepot < 0 ? 'decrease' : ''">{{ fourWeekTrend.containersAtDepot | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.containersAtDepot > 0 ? 'increase' : twelveWeekTrend.containersAtDepot < 0 ? 'decrease' : ''">{{ twelveWeekTrend.containersAtDepot | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.containersAtOther > 0 ? 'increase' : fourWeekTrend.containersAtOther < 0 ? 'decrease' : ''">{{ fourWeekTrend.containersAtOther | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.containersAtOther > 0 ? 'increase' : twelveWeekTrend.containersAtOther < 0 ? 'decrease' : ''">{{ twelveWeekTrend.containersAtOther | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.totalContainers > 0 ? 'increase' : fourWeekTrend.totalContainers < 0 ? 'decrease' : ''">{{ fourWeekTrend.totalContainers | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.totalContainers > 0 ? 'increase' : twelveWeekTrend.totalContainers < 0 ? 'decrease' : ''">{{ twelveWeekTrend.totalContainers | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr class="padding-row"><td colspan="2"><div></div></td></tr>
                  <tr class="divider-row"><td colspan="2"></td></tr>
                  <tr class="padding-row"><td colspan="2"><div></div></td></tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.collectionsInWeek > 0 ? 'increase' : fourWeekTrend.collectionsInWeek < 0 ? 'decrease' : ''">{{ fourWeekTrend.collectionsInWeek | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.collectionsInWeek > 0 ? 'increase' : twelveWeekTrend.collectionsInWeek < 0 ? 'decrease' : ''">{{ twelveWeekTrend.collectionsInWeek | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.deliveriesInWeek > 0 ? 'increase' : fourWeekTrend.deliveriesInWeek < 0 ? 'decrease' : ''">{{ fourWeekTrend.deliveriesInWeek | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.deliveriesInWeek > 0 ? 'increase' : twelveWeekTrend.deliveriesInWeek < 0 ? 'decrease' : ''">{{ twelveWeekTrend.deliveriesInWeek | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.exchangesInWeek > 0 ? 'increase' : fourWeekTrend.exchangesInWeek < 0 ? 'decrease' : ''">{{ fourWeekTrend.exchangesInWeek | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.exchangesInWeek > 0 ? 'increase' : twelveWeekTrend.exchangesInWeek < 0 ? 'decrease' : ''">{{ twelveWeekTrend.exchangesInWeek | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.totalJobs > 0 ? 'increase' : fourWeekTrend.totalJobs < 0 ? 'decrease' : ''">{{ fourWeekTrend.totalJobs | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.totalJobs > 0 ? 'increase' : twelveWeekTrend.totalJobs < 0 ? 'decrease' : ''">{{ twelveWeekTrend.totalJobs | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr class="padding-row"><td colspan="2"><div></div></td></tr>
                  <tr class="divider-row"><td colspan="2"></td></tr>
                  <tr class="padding-row"><td colspan="2"><div></div></td></tr>
                  @if (isAdmin && showTotalContainerDays()) {
                    <tr>
                      <td class="divider-col"><div [className]="fourWeekTrend.totalContainerDays > 0 ? 'decrease' : fourWeekTrend.totalContainerDays < 0 ? 'increase' : ''">{{ fourWeekTrend.totalContainerDays | number:'1.1-1' }}</div></td>
                      <td><div [className]="twelveWeekTrend.totalContainerDays > 0 ? 'decrease' : twelveWeekTrend.totalContainerDays < 0 ? 'increase' : ''">{{ twelveWeekTrend.totalContainerDays | number:'1.1-1' }}</div></td>
                    </tr>
                  }
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.slowMovers > 0 ? 'decrease' : fourWeekTrend.slowMovers < 0 ? 'increase' : ''">{{ fourWeekTrend.slowMovers | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.slowMovers > 0 ? 'decrease' : twelveWeekTrend.slowMovers < 0 ? 'increase' : ''">{{ twelveWeekTrend.slowMovers | number:'1.1-1' }}</div></td>
                  </tr>
                  @if (isAdmin && showSlowMovingDays()) {
                    <tr>
                      <td class="divider-col"><div [className]="fourWeekTrend.slowMovingDays > 0 ? 'decrease' : fourWeekTrend.slowMovingDays < 0 ? 'increase' : ''">{{ fourWeekTrend.slowMovingDays | number:'1.1-1' }}</div></td>
                      <td><div [className]="twelveWeekTrend.slowMovingDays > 0 ? 'decrease' : twelveWeekTrend.slowMovingDays < 0 ? 'increase' : ''">{{ twelveWeekTrend.slowMovingDays | number:'1.1-1' }}</div></td>
                    </tr>
                  }
                  <tr>
                    <td class="divider-col"><div [className]="fourWeekTrend.averageContainerDwell > 0 ? 'decrease' : fourWeekTrend.averageContainerDwell < 0 ? 'increase' : ''">{{ fourWeekTrend.averageContainerDwell | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.averageContainerDwell > 0 ? 'decrease' : twelveWeekTrend.averageContainerDwell < 0 ? 'increase' : ''">{{ twelveWeekTrend.averageContainerDwell | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr style="display: none;">
                    <td class="divider-col"><div [className]="fourWeekTrend.serviceFrequencyAverage > 0 ? 'decrease' : fourWeekTrend.serviceFrequencyAverage < 0 ? 'increase' : ''">{{ fourWeekTrend.serviceFrequencyAverage | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.serviceFrequencyAverage > 0 ? 'decrease' : twelveWeekTrend.serviceFrequencyAverage < 0 ? 'increase' : ''">{{ twelveWeekTrend.serviceFrequencyAverage | number:'1.1-1' }}</div></td>
                  </tr>
                  <tr style="display: none;">
                    <td class="divider-col"><div [className]="fourWeekTrend.projectedAnnualCollections > 0 ? 'increase' : fourWeekTrend.projectedAnnualCollections < 0 ? 'decrease' : ''">{{ fourWeekTrend.projectedAnnualCollections | number:'1.1-1' }}</div></td>
                    <td><div [className]="twelveWeekTrend.projectedAnnualCollections > 0 ? 'increase' : twelveWeekTrend.projectedAnnualCollections < 0 ? 'decrease' : ''">{{ twelveWeekTrend.projectedAnnualCollections | number:'1.1-1' }}</div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div><div class="row">
        <div class="col d-flex justify-content-end p-1">
          <button type="button" class="btn btn-secondary mt-2 mr-2 page-button" (click)="showPreviousKpiData()">&#60; Previous 12 Weeks</button>
          @if (showNext) {
            <button type="button" class="btn btn-secondary mt-2 ml-1 mr-2 page-button" (click)="showNextKpiData()">Next 12 Weeks &gt;</button>
          }
        </div>
      </div>
    </div>
  }
  @if (reportToShow == Reports.Inventory) {
    <div id="reportsContainer" class="reports-container"></div>
  }
</div>
</div>
